import { FhsAxios } from "../../services/axios";
import moment from "moment";

export default {
  state: {
    portfolioList: null,
    portfolioTotal: null,
    portfolioDate: moment()
      .subtract(1, "days")
      .format("DD.MM.YYYY")
  },
  actions: {
    fetchUserPortfolio({ commit, getters }) {
      commit("unsetUserPortfolio");
      commit("unsetUserPortfolioTotal");
      let url = "user/portfolio";
      //commit("unsetUserPortfolioTotal");
      // Если пользователь - VIP и пользователь выбрал определенного брокера, добавляем в запрос ID брокера (получаем данные только по выбранному брокеру)
      if (
        getters.selectedPortfolio !== "all" &&
        getters.selectedPortfolio !== undefined
      ) {
        url += "/" + getters.selectedPortfolio;
      }
      FhsAxios.post(url, {
        userId: getters.userId,
        date: this.state.portfolio.portfolioDate,
        pType: 1
      }).then(response => {
        commit("setUserPortfolio", response.data.result.portfolio);
        commit("setUserPortfolioTotal", response.data.result.total);
      });
    },
    setPortfolioDate({ commit }, date) {
      commit("setUserPortfolioDate", date);
    }
  },
  mutations: {
    setUserPortfolio(state, portfolioList) {
      state.portfolioList = portfolioList;
      state.portfolioTotal = null;
    },
    unsetUserPortfolio(state) {
      state.portfolioList = null;
    },
    setUserPortfolioTotal(state, portfolioTotal) {
      state.portfolioTotal = portfolioTotal;
    },
    unsetUserPortfolioTotal(state) {
      state.portfolioTotal = null;
    },
    setUserPortfolioDate(state, portfolioDate) {
      state.portfolioDate = portfolioDate;
    },
    unsetUserPortfolioDatuserPortfolioTotale(state) {
      state.portfolioDate = null;
    }
  },
  getters: {
    userPortfolio(state) {
      return state.portfolioList;
    },
    userPortfolioTotal(state) {
      return state.portfolioTotal;
    },
    userPortfolioDate(state) {
      return state.portfolioDate;
    }
  }
};
